import React, { useState } from 'react';
import SearchForm from '../ClinicalManagement/SearchForm';
import { Link } from 'react-router-dom';
import PageHeader from '../../../components/PageHeader';
import ProtectedComponent from '../../../common/ProtectedComponent';
import {
  permissionsList,
  permissionsWithAssignedIds,
} from '../../../api/constant';
import { setEmbryologyData } from '../../../actions/embryologyActions';
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import ButtonWithCheckbox from '../ClinicalManagement/components/buttonWithCheckbox';
import EmbryologySummary from './Components/EmbryologySummary';
import EmbryologyForms from './EmbryologyForms';
import EmbryologyDataAnalytics from './EmbryologyDataAnalytics';
import {
  completeFETCycleApi,
  completeOpuCycle,
  createNewFetCycle,
  createNewOpuCycle,
  fetchFetCycles,
  fetchOpuCycles,
  generateOPUSummaryReport,
} from '../../../api/embryologyApi';
import { toast } from 'sonner';
import { downloadFile, pollFileAvailability } from '../../../api/utils';
import { checkFileAvailabilityApi } from '../../../api/patientApi';

const EmbryologyLanding = () => {
  const [activeTab, setActiveTab] = useState(1);
  const [currentForm, setCurrentForm] = useState(0);
  const [selectedCycle, setSelectedCycle] = useState({
    id: 0,
    active: true,
  });

  const [selectedFetCycle, setSelectedFetCycle] = useState({
    id: 0,
    data: null,
  });
  const [isDownloadDisabled, setIsDownloadDisabled] = useState(false);

  const dispatch = useDispatch();
  const setPatient = async (data) => {
    const selectedPatientData = {
      patient: data.patient,
      patientFiles: data.patientFiles,
      isFetched: true,
    };
    dispatch(setEmbryologyData('selectedPatientData', selectedPatientData));

    const opuCycles = await fetchOpuCycles(data.patient.id);
    dispatch(setEmbryologyData('opuCycles', opuCycles.data.cycles));

    const fetCycles = await fetchFetCycles(data.patient.id);
    dispatch(setEmbryologyData('fetCycles', fetCycles.data.cycles));
  };

  const getNewCycleButtonState = () => {
    return opuCycles.some((cycle) => cycle.isActive);
  };

  const getNewFetCycleButtonState = () => {
    return fetCycles.some((cycle) => !cycle.isComplete);
  };

  const handleCompleteCycle = async (cycleId) => {
    try {
      const response = await completeOpuCycle(
        selectedPatientData.patient.id,
        cycleId,
      );
      dispatch(setEmbryologyData('opuCycles', response.data.cycles));
      toast.success('Cycle completed successfully');
    } catch (error) {
      toast.error('Error completing cycle');
      console.error('Error completing cycle:', error);
    }
  };

  const handleNewCycleCreation = async () => {
    try {
      const response = await createNewOpuCycle(selectedPatientData.patient.id);
      dispatch(setEmbryologyData('opuCycles', response.data.cycles));
      toast.success('Cycle created successfully');
    } catch (error) {
      toast.error('Error creating cycle');
      console.error('Error creating cycle:', error);
    }
  };

  const handleFreezingInventory = async () => {
    setCurrentForm(8);
  };

  const handleNewFetCycleCreation = async () => {
    try {
      const response = await createNewFetCycle(selectedPatientData.patient.id);
      dispatch(setEmbryologyData('fetCycles', response.data.cycles));
      toast.success('Cycle created successfully');
    } catch (error) {
      toast.error('Error creating cycle');
      console.error('Error creating cycle:', error);
    }
  };

  const handleCompleteFETCycle = async (patientId, cycleId) => {
    try {
      await completeFETCycleApi(patientId, cycleId);
      toast.success('FET Cycle completed successfully');

      const fetCycles = await fetchFetCycles(patientId);
      dispatch(setEmbryologyData('fetCycles', fetCycles.data.cycles));
    } catch (error) {
      toast.error('Error completing FET cycle');
    }
  };

  const tiles = [
    {
      title: 'Gamete & Fertilisation Details',
      checked: false,
      formId: 1,
      onClick: () => {
        setCurrentForm(1);
      },
    },
    {
      title: 'Embryo Biospy',
      checked: false,
      formId: 2,
      onClick: () => {
        setCurrentForm(2);
      },
    },
    {
      title: 'Fresh Embryo Transfer Sheet',
      checked: false,
      formId: 3,
      onClick: () => {
        setCurrentForm(3);
      },
    },
    {
      title: 'Oocyte-Embryo Record',
      checked: false,
      formId: 4,
      onClick: () => {
        setCurrentForm(4);
      },
    },
    {
      title: 'Embryo Cryopreservation',
      checked: false,
      formId: 5,
      onClick: () => {
        setCurrentForm(5);
      },
    },
    // {
    //   title: 'Frozen Embryo Transfer Sheet',
    //   checked: false,
    //   onClick: () => {
    //formId: 6,
    //     setCurrentForm(6);
    //   },
    // },
    {
      title: 'View & Download Embryology Summary',
      checked: false,
      formId: 7,
      onClick: () => {
        setCurrentForm(7);
      },
    },
  ];

  const selectedPatientData = useSelector(
    (state) => state.embryologyReducer.selectedPatientData,
  );

  const opuCycles = useSelector((state) => state.embryologyReducer.opuCycles);
  const fetCycles = useSelector((state) => state.embryologyReducer.fetCycles);
  const handleReportDownload = async (cycleId) => {
    try {
      setIsDownloadDisabled(true);

      const res = await generateOPUSummaryReport(
        selectedPatientData.patient.id,
        cycleId,
      );

      if (res.data.result && res.data.result.file) {
        // setIsDownloadDisabled(false);

        toast.success('Generated report');

        try {
          const presignedUrl = await pollFileAvailability(
            checkFileAvailabilityApi,
            res.data.result.file.bucketName,
            res.data.result.file.fileKey,
          );
          // dispatch(
          //   setEmbryologyData('summary.reportId', res.data.result.file.id),
          // );
          downloadFile(presignedUrl, selectedPatientData.patient.id);
          toast.success('Report is downloaded successfully');
        } catch (error) {
          setIsDownloadDisabled(false);
          console.error('Failed to get presigned URL:', error);
        } finally {
          setIsDownloadDisabled(false);
        }
      }
    } catch (error) {
      setIsDownloadDisabled(false);
      toast.error('Error generating report:', error);
    }
  };
  return (
    <ProtectedComponent
      requiredPermission={
        permissionsWithAssignedIds[permissionsList.EmbrologyManager]
      }
    >
      <div className=" container-fluid">
        <div style={{ width: '100%' }} className="theme-blush ">
          <PageHeader
            HeaderText="Fertility Management"
            Breadcrumb={[
              {
                name: 'Embryology Management',
                navigate: '/embrology',
              },
            ]}
          />
          {currentForm === 0 && (
            <ul
              className="nav nav-tabs"
              role="tablist"
              style={{
                background: '#ffff',
              }}
            >
              <li
                className={`nav-item mr-1 ${activeTab === 1 ? 'active' : ''}`}
                onClick={() => setActiveTab(1)}
              >
                <Link
                  to="#"
                  className={`nav-link ${activeTab === 1 ? 'active' : ''}`}
                >
                  Search Patient
                </Link>
              </li>

              <li
                className={`nav-item mr-1 ${activeTab === 2 ? 'active' : ''}`}
                onClick={() => setActiveTab(2)}
              >
                <Link
                  to="#"
                  className={`nav-link ${activeTab === 2 ? 'active' : ''}`}
                >
                  Data Analytics
                </Link>
              </li>
            </ul>
          )}
          <div className="tab-content component-wrapper">
            {activeTab === 1 && currentForm === 0 && (
              <>
                <div className="tab-pane show active">
                  <SearchForm
                    embryology={true}
                    patientDataHandler={setPatient}
                  />
                </div>
              </>
            )}

            {activeTab === 1 &&
              currentForm === 0 &&
              selectedPatientData &&
              selectedPatientData.isFetched && (
                <>
                  <button
                    className="btn btn-primary mb-3"
                    disabled={getNewCycleButtonState()}
                    onClick={handleNewCycleCreation}
                  >
                    Create New Cycle
                  </button>

                  <button
                    className="btn btn-primary mb-3 ml-3"
                    onClick={handleFreezingInventory}
                  >
                    Freezing Inventory
                  </button>

                  {opuCycles &&
                    opuCycles.map((cycle, index) => (
                      <>
                        <div className="card" style={{ padding: '20px' }}>
                          <h3>
                            CYCLE {opuCycles.length - index} :{' '}
                            <span
                              style={{
                                color: cycle.isActive ? 'green' : 'red',
                              }}
                            >
                              {cycle.isActive ? 'Active' : 'Completed'}
                            </span>
                          </h3>
                          <Grid container spacing={2}>
                            {tiles.map((tile, index) => (
                              <Grid item xs={6} md={4} key={index}>
                                <button
                                  className="btn btn-primary"
                                  style={{
                                    width: '200px',
                                    height: '100px',
                                    backgroundColor: 'white',
                                    color: 'black',
                                    border: '1px solid black',
                                  }}
                                  onClick={() => {
                                    setSelectedCycle({
                                      id: cycle.id,
                                      active: cycle.isActive,
                                    });
                                    setCurrentForm(tile.formId);
                                  }}
                                >
                                  {tile.title}
                                </button>
                              </Grid>
                            ))}
                          </Grid>
                          <div className="card-body flex gap-10">
                            <button
                              className="btn btn-primary"
                              disabled={!cycle.isActive}
                              onClick={() => handleCompleteCycle(cycle.id)}
                            >
                              Complete Cycle
                            </button>
                            <button
                              className="btn btn-primary"
                              disabled={isDownloadDisabled}
                              onClick={() => handleReportDownload(cycle.id)}
                            >
                              Download Complete OPU Cycle Details
                            </button>
                          </div>
                        </div>
                      </>
                    ))}

                  <div className="card mt-3">
                    <div className="card-body">
                      <h3>FET CYCLES</h3>
                      <button
                        className="btn btn-primary mb-3"
                        disabled={getNewFetCycleButtonState()}
                        onClick={handleNewFetCycleCreation}
                      >
                        Create New Cycle
                      </button>

                      <Grid container spacing={2}>
                        {fetCycles &&
                          fetCycles.map((cycle, index) => (
                            <Grid item xs={4} md={4} key={index}>
                              <div
                                style={{
                                  border: '1px solid black',
                                  textAlign: 'center',
                                  padding: '10px',
                                  width: '220px',
                                }}
                              >
                                Fet Cycle {index + 1}{' '}
                                <span
                                  style={{
                                    color: cycle.isComplete ? 'green' : 'red',
                                  }}
                                >
                                  {cycle.isComplete ? 'Completed' : 'Active'}
                                </span>
                                <button
                                  className="btn btn-primary"
                                  style={{
                                    width: '200px',
                                    height: '100px',
                                    backgroundColor: 'white',
                                    color: 'black',
                                    border: '1px solid black',
                                  }}
                                  onClick={() => {
                                    setSelectedFetCycle({
                                      id: cycle.cycleId,
                                      data: cycle.frozenDetails,
                                    });
                                    setCurrentForm(6);
                                  }}
                                >
                                  Frozen Embryo Transfer Sheet
                                </button>
                              </div>
                            </Grid>
                          ))}
                      </Grid>
                    </div>
                  </div>
                </>
              )}

            {currentForm > 0 && (
              <EmbryologyForms
                currentForm={currentForm}
                setCurrentForm={setCurrentForm}
                selectedCycle={selectedCycle}
                tiles={tiles}
                selectedFetCycle={selectedFetCycle}
                setSelectedFetCycle={setSelectedFetCycle}
                setSelectedCycle={setSelectedCycle}
                patientDataHandler={setPatient}
                handleCompleteFETCycle={handleCompleteFETCycle} // Pass the method as a prop
              />
            )}

            {activeTab === 2 && <EmbryologyDataAnalytics />}
          </div>
        </div>
      </div>
    </ProtectedComponent>
  );
};

export default EmbryologyLanding;
